import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { getSelectedTab } from '@/common/hooks/useTabs/helpers'
import routes from '@/Router/routes.constants'

const useConfigurationPermissionRedirect = ({ tabs, returnPortalFeatures }) => {
  const navigate = useNavigate()

  useEffect(() => {
    const currentTab = getSelectedTab(window.location.pathname, tabs)

    if (currentTab?.disabled && returnPortalFeatures) {
      navigate(routes.dashboardPage)
    }
  }, [tabs, navigate, returnPortalFeatures])
}

export default useConfigurationPermissionRedirect
